module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_pet@2x-a7f63e04f730cc3ea97a0f266f8fb49b.webp";